import React from 'react';

import { Input } from 'antd';

import FormItem from './FormItem';

const TextField = ({
    maxLength = 255,
    maxLengthMsg,
    type,
    disabled,
    onBlur,
    defaultValue,
    prefix,
    notAllowWhiteSpace,
    onlyNumber,
    readOnly = false,
    addonAfter,
    insideRef,
    regex,
    ...formItemProps
}) => {

    const getMaxLengthMsg = () => {
        return maxLengthMsg || `This field cannot be longer than ${maxLength} characters`;
    }

    const getTextFieldRules = () => {
        const rules = [];
        if (maxLength) {
            rules.push({ max: maxLength, message: getMaxLengthMsg() });
        }
        if (notAllowWhiteSpace) {
            rules.push({ whitespace: true, message: 'This field cannot have only whitespace values!' });
        }
        return rules;
    }

    const InputText = ({ getPlaceHolder, ...inputProps }) => {
        const handleChange = (e) => {
            let value = e.target.value
            if (onlyNumber) {
                value = e.target.value.replace(/\D/g,'')
            }
            if (regex) {
                value = e.target.value.replace(regex, '');
            }
            inputProps.onChange?.(value);
        }

        return (
            <Input
                placeholder={getPlaceHolder()}
                defaultValue={defaultValue}
                disabled={disabled}
                type={type}
                onBlur={onBlur}
                prefix={prefix}
                readOnly={readOnly}
                addonAfter={addonAfter}
                ref={insideRef}
                {...inputProps}
                onChange={handleChange}
            />
        )
    }

    return (
        <FormItem
            {...formItemProps}
            fieldRules={getTextFieldRules()}
        >
            <InputText />
        </FormItem>
    )
}

export default TextField;
